import {
  grayPaletteDark,
  greenPaletteDark,
  redPaletteDark,
  yellowPaletteDark,
  royalBluePaletteDark,
} from '../../themes/dark-colors';
import { opacity } from '../../utils';

export const NotificationDarkTheme = {
  borderColor: grayPaletteDark[300],
  backgroundColor: grayPaletteDark[0],
  shadowFrom: opacity(grayPaletteDark[1000], 15),
  shadowTo: opacity(grayPaletteDark[1000], 5),
  success: {
    accentColor: greenPaletteDark[600],
    iconColor: greenPaletteDark[600],
  },
  info: {
    accentColor: grayPaletteDark[500],
    iconColor: grayPaletteDark[700],
  },
  warning: {
    accentColor: yellowPaletteDark[600],
    iconColor: yellowPaletteDark[600],
  },
  danger: {
    accentColor: redPaletteDark[600],
    iconColor: redPaletteDark[600],
  },
  progress: {
    accentColor: royalBluePaletteDark[1000],
    iconColor: royalBluePaletteDark[1000],
  },
};
